import { useProductFetcher } from 'components/WorkspaceEditor/api/useProductFetcher/useProductFetcher'
import { useProductFetcherUtils } from 'components/WorkspaceEditor/api/useProductFetcher/useProductFetcher.utils'
import {
    GetProjectNuggetContentViewResponse,
    GetProjectProductFamilyViewResponse,
} from 'components/WorkspaceEditor/types'
import { useShallowSelector } from 'components/WorkspaceEditor/Workspace2Store'
import { useCallback } from 'react'

export type TabName = 'general' | 'products' | 'execution'

export const tabIndex: Record<TabName, number> = {
    general: 1,
    products: 2,
    execution: 3,
}

export const useHandleActiveTab = () => {
    const { setIsTreeLoading, activeTab, setActiveTab } = useShallowSelector(
        (state) => ({
            setIsTreeLoading: state.actions.setIsTreeLoading,
            activeTab: state.activeTab,
            setActiveTab: state.actions.setActiveTab,
        })
    )
    const { onContentViewFetchSuccess } = useProductFetcherUtils({
        overrideContentItemNodes: true,
    })
    const { getContentItemViewNodesAPI } = useProductFetcher({
        overrideContentItemNodes: true,
        callback: async (
            response:
                | GetProjectProductFamilyViewResponse
                | GetProjectNuggetContentViewResponse
        ) => {
            await onContentViewFetchSuccess(response, [], false)
            setIsTreeLoading(false)
        },
    })

    const handleTrackChangeFromActiveTab = useCallback(
        async (trackChangeTab: string) => {
            // Returns true if the track change belongs to the currently active tab
            const tab = trackChangeTab.toLowerCase() as TabName

            if (tabIndex[tab] === activeTab) {
                return true
            }

            try {
                setActiveTab(tabIndex[tab])
                setIsTreeLoading(true)
                await getContentItemViewNodesAPI([], tabIndex[tab])
                return true
            } catch (error) {
                console.error(
                    `Error in handleTrackChangeFromActiveTab: ${error}`
                )
                setIsTreeLoading(false)
                return false
            }
        },
        [
            activeTab,
            tabIndex,
            getContentItemViewNodesAPI,
            setIsTreeLoading,
            setActiveTab,
        ]
    )

    return handleTrackChangeFromActiveTab
}
